import BaseAPI from '../BaseAPI';
import OrganizerInvitation from '../../models/inkind-organizers/OrganizerInvitation';
import Http from '../Http';
import InkindOrganizerSettings from '../../models/inkinds/InkindOrganizerSettings';

export default class InKindOrganizersAPI extends BaseAPI {
  public async inviteUserAsPageOrganizer(routeId: string, invitation: OrganizerInvitation): Promise<void> {
    const url: string = this.buildAPIEndPoint(`/inkinds/${routeId}/organizers`);
    await Http.post({
      url,
      body: JSON.stringify(invitation),
    });
  }

  public async cancelOrganizerInvitation(routeId: string, emailAddress: string): Promise<void> {
    const url: string = this.buildAPIEndPoint(`/inkinds/${routeId}/invitees`);
    await Http.delete({
      url,
      body: JSON.stringify({ emailAddress }),
    });
  }

  public async setOrganizerSettings(routeId: string, userId: string, settings: InkindOrganizerSettings): Promise<void> {
    const url: string = this.buildAPIEndPoint(`/inkinds/${routeId}/organizers/${userId}`);
    await Http.put({
      url,
      body: JSON.stringify(settings),
    });
  }

  public async setOwnerSettings(routeId: string, settings: InkindOrganizerSettings): Promise<void> {
    const url: string = this.buildAPIEndPoint(`/inkinds/${routeId}/owner`);
    await Http.put({
      url,
      body: JSON.stringify(settings),
    });
  }

  public async removePageOrganizer(routeId: string, userId: string): Promise<void> {
    const url: string = this.buildAPIEndPoint(`/inkinds/${routeId}/organizers/${userId}`);
    await Http.delete({ url });
  }
}
